import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with your publishable key.
// Single shared instance — import stripePromise from here, don't call
// loadStripe() again elsewhere (Pricing.jsx previously did this too).
export const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

// Single flat plan — replaces the old basic/standard/premium tiers.
// Create these two Prices in the Stripe dashboard under the Pitchallo
// product ($60/mo AUD recurring, $600/yr AUD recurring) and paste the
// real price IDs in below before deploying.
export const PLAN = {
  name: 'Pitchallo',
  currency: 'AUD',
  monthly: {
    price: 60,
    priceId: 'price_1U77yJRQeD0eMHGLaFeCBpB5',
  },
  yearly: {
    price: 600,
    priceId: 'price_1U77z5RQeD0eMHGLWzUOElqB',
    savings: {
      amount: 120,
      months: 2,
    },
  },
};

// TEMPORARY COMPATIBILITY SHIM — DO NOT LEAVE THIS IN PLACE.
// Some other file in the codebase still imports SUBSCRIPTION_TIERS directly
// (this is what broke the Netlify build). This shim points all three old
// tier keys at the same new flat plan so the build passes again immediately,
// but it does NOT fix any tier-specific logic elsewhere — e.g. code that
// checks `tier === 'premium'` to unlock a feature, or compares pitch/team
// counts against the old per-tier limits (3/8/20 pitches, 60/100/150 teams).
// That logic will keep running against these old, now-meaningless tier
// names until you find it and remove it. Find every remaining reference
// with: grep -rn "SUBSCRIPTION_TIERS" --include="*.js" --include="*.jsx" src netlify
// then delete this shim once nothing else depends on it.
export const SUBSCRIPTION_TIERS = {
  basic: PLAN,
  standard: PLAN,
  premium: PLAN,
  pitchallo: PLAN,
};
